import { Card, Col, Row, Tabs } from 'antd';
import React, { useState } from 'react';
import { Token } from '../types';
import useUpdateAndProcessPaymentMethod from '../hooks/useUpdateAndProcessPaymentMethod';
import CreditCardPaymentMethod from '../payment/CreditCardPaymentMethod';
import PayPalPaymentMethod from '../payment/PayPalPaymentMethod';

const { TabPane } = Tabs;

type Props = {
    cardType: string;
    lastFour: string;
    paypalBillingAgreementId: string;
};

export default function UpdatePaymentMethod({ cardType, lastFour, paypalBillingAgreementId }: Props) {
    const [errorMessage, setErrorMessage] = useState<string>('');

    const { updatePaymentMethod, removePendingTokens, pendingPaymentTokens, isUpdatingPaymentMethod } = useUpdateAndProcessPaymentMethod();

    const handleToken = async (token: Token) => {
        setErrorMessage('');

        const result = await updatePaymentMethod(token.id);

        if (result?.error) {
            setErrorMessage(result.error);
        }
    };

    const handle3DSecureResultToken = async (token: Token) => {
        setErrorMessage('');

        const result = await updatePaymentMethod(pendingPaymentTokens.creditCardToken, token.id);

        if (result?.error) {
            setErrorMessage(result.error);
        }
    };

    // TODO fix any type to be 'RecurlyError', type is not visible
    const handle3DSecureError = (error: any) => {
        const message = error.message || 'We were unable to authenticate your payment method… choose a different payment method and try again.';
        setErrorMessage(message);
        removePendingTokens();
    };

    const handleError = (error: string) => {
        setErrorMessage(error);
    };

    return (
        <div className="payment-method-container">
            <Row gutter={24}>
                <Col
                    sm={24}
                    lg={12}
                    xl={12}
                >
                    <Card title="Attach a payment method">
                        <p>Please enter your preferred payment method below. You can use a credit / debit card or pay through a PayPal account.</p>
                        <Tabs>
                            <TabPane
                                tab="Credit card"
                                key="credit-card"
                            >
                                <CreditCardPaymentMethod
                                    buttonLabel="Save"
                                    showAvailableCards
                                    threeDSecureActionToken={pendingPaymentTokens.threeDSecureActionToken}
                                    isLoading={isUpdatingPaymentMethod}
                                    errorMessage={errorMessage}
                                    onToken={handleToken}
                                    on3DSecureResultToken={handle3DSecureResultToken}
                                    on3DSecureError={handle3DSecureError}
                                    onError={handleError}
                                />
                            </TabPane>
                            <TabPane
                                tab="PayPal"
                                key="paypal"
                            >
                                <PayPalPaymentMethod
                                    buttonLabel="Subscribe with PayPal"
                                    onToken={handleToken}
                                />
                            </TabPane>
                        </Tabs>
                    </Card>
                </Col>
                <Col
                    sm={24}
                    lg={12}
                    xl={12}
                >
                    <Card title="Current payment method">
                        <div className="current-payment-method">
                            {cardType && lastFour && (
                                <div className="card">
                                    <img
                                        src={`/images/${cardType.replace(' ', '_').toLowerCase()}_light.png`}
                                        alt={cardType}
                                        title={cardType}
                                    />
                                    <span className="last4">&nbsp;****&nbsp;{lastFour}</span>
                                </div>
                            )}

                            {paypalBillingAgreementId && (
                                <div className="paypal">
                                    <img
                                        src="/images/paypal.png"
                                        alt="PayPal"
                                        title="PayPal"
                                    />
                                    <span className="last4">&nbsp;Billing agreement: &nbsp;{paypalBillingAgreementId}</span>
                                </div>
                            )}

                            {!cardType && !lastFour && !paypalBillingAgreementId && <p>You don't have a payment method attached to your account!</p>}
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
